import Cookies from 'js-cookie';
import React, { FC, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { GROUPS } from '../../app/constants';

export const TourGroup: FC = () => {
  const params = useParams();

  useEffect(() => {
    if (params.group && GROUPS.includes(params.group)) {
      Cookies.set('tourGroup', params.group, { expires: 365 });
      window.location.assign('/');
    }
  }, [params]);

  return <div></div>;
};
